import { MealTime } from "@/clients/models/MealTime";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetGotoMeal = (mealTime: MealTime) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.GO_TO_SELECT_MEAL, mealTime],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.getGotoMealsForMealTimeApiV1MealsGotoMealTimeGet(
          mealTime,
          user.id,
        );
      return data;
    },
  });
  return {
    selectedMeals: data,
    isLoading,
    error,
  };
};
